"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeHtml = exports.md = void 0;
exports.md = require("markdown-it")({
    breaks: true,
    linkify: true,
});
exports.md.linkify.set({ fuzzyLink: false });
exports.escapeHtml = exports.md.utils.escapeHtml;
